import AmplitudeTracker from './AmplitudeTracker';
import CombinedTracker from './CombinedTracker';

const tracker = new CombinedTracker([new AmplitudeTracker()]);
export default tracker;
